import { render } from "./BaseLayout.vue?vue&type=template&id=105e0713"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script